import Codeblock from './Codeblock.static';
export default Codeblock;